<div  (click)="ordering(colName)">
    <i class="fa-solid fa-arrow-right-arrow-left" style="transform: rotate(90deg);" bTooltip title="Ordinamento {{colValue}}"
        *ngIf=" baseSearchCriteria.orderBy!==colName || baseSearchCriteria.descOrder===undefined"></i>
    <i class="fa-solid fa-arrow-down-z-a"
        *ngIf="baseSearchCriteria.orderBy===colName && (baseSearchCriteria.descOrder !== undefined && baseSearchCriteria.descOrder === true)"></i><i
        class="fa-solid fa-arrow-up-a-z"
        *ngIf="baseSearchCriteria.orderBy===colName && (baseSearchCriteria.descOrder !== undefined && baseSearchCriteria.descOrder === false)">
       
    </i>
    {{colValue}}
</div>